module.exports = __webpack_public_path__ + "images/cert-GMP.7de771dd.png";